module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LT-5dfce51f8a4b694c8ff6971145bb130f.png";